import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'

export const DatePickerContainer = ({ children }) => {
  return (
    <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="en">
      {children}
    </LocalizationProvider>
  );
}